import heroBg from '@/assets/guide/bg.png';
import gen1 from '@/assets/guide/gen-1.png';
import gen2 from '@/assets/guide/gen-2.png';
import gen3 from '@/assets/guide/gen-3.png';
import tech1 from '@/assets/guide/tech-1.png';
import tech2 from '@/assets/guide/tech-2.png';

export const HERO = {
  title: '爱学智引平台',
  image: heroBg,
  subtitle: (
    <>
      爱学智引平台以全流程 AI 驱动为核心，依托爱学自研语音、数字人、大模型、AI 工程底座及成熟 AI
      业务系统，面向自主学习、知识共享、企业内训等多元场景，
      <br />
      提供从教学内容智能生成到 AI 授课交付的一站式闭环服务，实现课程从0到1的自动化构建。
    </>
  ),
};

export const GENERATE = {
  title: '极简生成，全栈赋能',
  subTitle: '一句话需求生成 AI 互动课程，一站式赋能企业 AI 教学转型',
  smallCards: [
    {
      title: '极简课程生成',
      description: '不用繁琐的教案、大纲、PPT准备。\n一句话需求即可生成数字人互动课程。',
      image: gen1,
    },
    {
      title: '不只内容生产，更是闭环交付',
      description: '从内容产出到消费体验、数据监测一次打通。无需自备产品或平台，一键闭环交付。',
      image: gen2,
    },
  ],
  wideCard: {
    title: '企业级全栈赋能',
    description:
      '支持企业快速接入，赋能教研团队从0到1搭建AI课程体系，完整覆盖课程生产、学员与组织管理、学习数据实时监测、学员行课全流程跟踪等核心环节，助力企业高效完成AI教学转型。',
    image: gen3,
  },
};

export const TECH = {
  title: '智引平台，两大技术底座',
  subTitle: '技术双引擎，驱动AI学习的个性化未来',
  rows: [
    {
      title: '一站式学习内容\n生成Agent',
      description:
        '基于多模态大模型与编排引擎，自动完成课程结构化编排、知识点拆解、内容生成与多层级适配，可针对不同基础、不同目标的学习者生成差异化学习资源，实现因材施教。',
      image: tech1,
      reverse: false,
    },
    {
      title: '高自由度的定制化能力',
      description:
        '支持实时复刻个人形象与音色，快速生成专属数字人讲师，并应用于课程讲解与互动环节，实现真正意义上的AI个性化引导。',
      image: tech2,
      reverse: true,
    },
  ],
};
